var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.3997 123.392C116.606 123.392 142.715 97.2826 142.715 64.9618C142.715 32.641 116.491 6.53125 84.3997 6.53125C52.1939 6.53125 26.0842 32.641 26.0842 64.9618C26.0842 97.2826 52.1939 123.392 84.3997 123.392Z",
    fill: "#0078FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.338 102.662C148.943 102.662 151.054 100.55 151.054 97.9458C151.054 95.3413 148.943 93.23 146.338 93.23C143.734 93.23 141.623 95.3413 141.623 97.9458C141.623 100.55 143.734 102.662 146.338 102.662Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.24 84.2585C155.018 84.2585 156.46 82.8166 156.46 81.038C156.46 79.2593 155.018 77.8174 153.24 77.8174C151.461 77.8174 150.019 79.2593 150.019 81.038C150.019 82.8166 151.461 84.2585 153.24 84.2585Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1896 26.5442C30.9683 26.5442 32.4102 25.1023 32.4102 23.3236C32.4102 21.5449 30.9683 20.103 29.1896 20.103C27.4109 20.103 25.969 21.5449 25.969 23.3236C25.969 25.1023 27.4109 26.5442 29.1896 26.5442Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52112 88.656C12.8244 88.656 15.5022 85.9782 15.5022 82.6749C15.5022 79.3717 12.8244 76.6938 9.52112 76.6938C6.21786 76.6938 3.54004 79.3717 3.54004 82.6749C3.54004 85.9782 6.21786 88.656 9.52112 88.656Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.891 66.3411L131 65.4042C131.225 65.3389 131.225 65.0121 131 64.9467L127.891 64.0098C127.811 63.988 127.753 63.9299 127.731 63.85L126.795 60.7489C126.729 60.5238 126.402 60.5238 126.337 60.7489L125.4 63.85C125.378 63.9299 125.32 63.988 125.24 64.0098L122.139 64.9467C121.914 65.0121 121.914 65.3389 122.139 65.4042L125.248 66.3411C125.328 66.3629 125.386 66.421 125.407 66.5009L126.344 69.6093C126.41 69.8344 126.737 69.8344 126.802 69.6093L127.739 66.5009C127.753 66.421 127.811 66.3629 127.891 66.3411Z",
    fill: "#ADB6C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M109.488 32.9853L112.597 32.0485C112.822 31.9832 112.822 31.6564 112.597 31.591L109.488 30.6542C109.408 30.6324 109.35 30.5743 109.328 30.4944L108.392 27.3935C108.326 27.1683 107.999 27.1683 107.934 27.3935L106.997 30.4944C106.975 30.5743 106.917 30.6324 106.837 30.6542L103.736 31.591C103.511 31.6564 103.511 31.9832 103.736 32.0485L106.845 32.9853C106.925 33.0071 106.983 33.0652 107.004 33.1451L107.941 36.2533C108.007 36.4785 108.333 36.4785 108.399 36.2533L109.336 33.1451C109.35 33.0652 109.408 33.0071 109.488 32.9853Z",
    fill: "#ADB6C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7395 36.8663L65.4594 36.0466C65.6564 35.9894 65.6564 35.7034 65.4594 35.6463L62.7395 34.8265C62.6696 34.8075 62.6188 34.7566 62.5997 34.6867L61.78 31.9734C61.7228 31.7764 61.4368 31.7764 61.3796 31.9734L60.5599 34.6867C60.5408 34.7566 60.49 34.8075 60.4201 34.8265L57.7066 35.6463C57.5096 35.7034 57.5096 35.9894 57.7066 36.0466L60.4264 36.8663C60.4963 36.8854 60.5472 36.9362 60.5662 37.0061L61.386 39.7258C61.4432 39.9228 61.7291 39.9228 61.7863 39.7258L62.6061 37.0061C62.6188 36.9362 62.6696 36.8854 62.7395 36.8663Z",
    fill: "#ADB6C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1861 86.8182L45.9059 85.8813C46.1029 85.8159 46.1029 85.4891 45.9059 85.4237L43.1861 84.4869C43.1162 84.4651 43.0653 84.407 43.0463 84.3271L42.2265 81.226C42.1693 81.0008 41.8834 81.0008 41.8262 81.226L41.0064 84.3271C40.9873 84.407 40.9365 84.4651 40.8666 84.4869L38.1531 85.4237C37.9561 85.4891 37.9561 85.8159 38.1531 85.8813L40.8729 86.8182C40.9428 86.8399 40.9937 86.898 41.0128 86.9779L41.8325 90.0863C41.8897 90.3114 42.1757 90.3114 42.2329 90.0863L43.0526 86.9779C43.0653 86.898 43.1162 86.8399 43.1861 86.8182Z",
    fill: "#ADB6C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8314 51.3953L40.7741 50.8098C40.9148 50.7689 40.9148 50.5647 40.7741 50.5238L38.8314 49.9383C38.7814 49.9247 38.7451 49.8884 38.7315 49.8385L38.146 47.9004C38.1051 47.7597 37.9008 47.7597 37.86 47.9004L37.2744 49.8385C37.2608 49.8884 37.2245 49.9247 37.1746 49.9383L35.2364 50.5238C35.0957 50.5647 35.0957 50.7689 35.2364 50.8098L37.1791 51.3953C37.2291 51.4089 37.2654 51.4452 37.279 51.4951L37.8645 53.4377C37.9054 53.5784 38.1096 53.5784 38.1505 53.4377L38.736 51.4951C38.7451 51.4452 38.7814 51.4089 38.8314 51.3953Z",
    fill: "#ADB6C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5347 70.6106L61.4775 70.0251C61.6182 69.9843 61.6182 69.78 61.4775 69.7392L59.5347 69.1537C59.4848 69.1401 59.4485 69.1037 59.4349 69.0538L58.8493 67.1158C58.8085 66.9751 58.6042 66.9751 58.5634 67.1158L57.9778 69.0538C57.9642 69.1037 57.9279 69.1401 57.878 69.1537L55.9398 69.7392C55.7991 69.78 55.7991 69.9843 55.9398 70.0251L57.8825 70.6106C57.9324 70.6242 57.9687 70.6605 57.9824 70.7105L58.5679 72.653C58.6088 72.7937 58.813 72.7937 58.8539 72.653L59.4394 70.7105C59.4485 70.6605 59.4848 70.6242 59.5347 70.6106Z",
    fill: "#ADB6C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0076 15.8709L77.9504 15.2854C78.0911 15.2445 78.0911 15.0403 77.9504 14.9994L76.0076 14.4139C75.9577 14.4003 75.9214 14.364 75.9078 14.3141L75.3222 12.376C75.2814 12.2353 75.0771 12.2353 75.0363 12.376L74.4507 14.3141C74.4371 14.364 74.4008 14.4003 74.3509 14.4139L72.4127 14.9994C72.272 15.0403 72.272 15.2445 72.4127 15.2854L74.3554 15.8709C74.4053 15.8845 74.4416 15.9208 74.4553 15.9707L75.0408 17.9133C75.0817 18.054 75.2859 18.054 75.3268 17.9133L75.9123 15.9707C75.9214 15.9208 75.9577 15.8845 76.0076 15.8709Z",
    fill: "#ADB6C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M122.042 99.0891L123.985 98.5036C124.126 98.4628 124.126 98.2585 123.985 98.2177L122.042 97.6322C121.992 97.6186 121.956 97.5823 121.942 97.5323L121.357 95.5943C121.316 95.4536 121.112 95.4536 121.071 95.5943L120.485 97.5323C120.472 97.5823 120.435 97.6186 120.386 97.6322L118.447 98.2177C118.307 98.2585 118.307 98.4628 118.447 98.5036L120.39 99.0891C120.44 99.1027 120.476 99.1391 120.49 99.189L121.075 101.132C121.116 101.272 121.321 101.272 121.361 101.132L121.947 99.189C121.956 99.1391 121.992 99.1027 122.042 99.0891Z",
    fill: "#ADB6C8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.222 73.877C62.3305 77.4408 55.9016 82.6118 55.9016 87.1539C55.9016 89.9575 55.9016 94.0125 55.9016 96.7058C55.9016 97.6475 57.2375 98.2046 58.0015 97.6541C60.2976 95.9997 64.4902 93.9276 70.646 94.4912C80.5688 95.3996 68.8991 78.7685 68.8991 78.7685L67.222 73.877Z",
    fill: "url(#paint0_linear_17055_49100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.79 73.877C107.682 77.5106 114.111 82.6118 114.111 87.1539C114.111 89.9575 114.111 94.0125 114.111 96.7058C114.111 97.6475 112.775 98.2046 112.011 97.6541C109.715 95.9997 105.522 93.9276 99.3664 94.4912C89.4436 95.3996 101.113 78.7685 101.113 78.7685L102.79 73.877Z",
    fill: "url(#paint1_linear_17055_49100)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_17055_49100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.9713 23.8433C75.7473 30.4119 64.7064 46.5539 66.7329 67.0982C68.6895 87.6426 70.4365 97.775 74.2099 100.221C78.0533 102.667 81.8267 103.226 84.9713 103.226C88.1158 103.226 91.8893 102.667 95.7326 100.221C99.5759 97.775 101.253 87.6426 103.21 67.0982C105.166 46.5539 94.1254 30.4119 84.9713 23.8433Z",
    fill: "url(#paint2_linear_17055_49100)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_17055_49100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9592 106.091H77.9835C76.8654 106.091 76.0269 105.183 76.0269 104.135V100.71H93.9857V104.065C93.9158 105.183 93.0074 106.091 91.9592 106.091Z",
    fill: "url(#paint3_linear_17055_49100)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M85.9498 72.7583H83.9932V98.5436H85.9498V72.7583Z",
    fill: "url(#paint4_linear_17055_49100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9715 58.7129C88.7922 58.7129 91.8895 55.6157 91.8895 51.795C91.8895 47.9742 88.7922 44.877 84.9715 44.877C81.1508 44.877 78.0535 47.9742 78.0535 51.795C78.0535 55.6157 81.1508 58.7129 84.9715 58.7129Z",
    stroke: "url(#paint5_linear_17055_49100)",
    strokeWidth: 4,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.545 119.438C94.545 125.098 90.0029 153.469 84.3427 153.469C78.6825 153.469 74.1404 125.098 74.1404 119.438C74.1404 113.777 78.6825 109.235 84.3427 109.235C90.0029 109.235 94.545 113.847 94.545 119.438Z",
    fill: "url(#paint6_linear_17055_49100)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.3425 140.401C82.316 136.069 80.01 124.05 80.01 120.207C80.01 117.831 81.9666 115.874 84.3425 115.874C86.7184 115.874 88.675 117.831 88.675 120.207C88.675 124.05 86.369 135.999 84.3425 140.401Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_17055_49100",
    x: 44.4897,
    y: 12.8433,
    width: 80.9475,
    height: 123.382,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17055_49100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17055_49100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_17055_49100",
    x: 54.0269,
    y: 89.7104,
    width: 61.9587,
    height: 49.3809,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17055_49100"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_17055_49100",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17055_49100",
    x1: 65.2747,
    y1: 74.7678,
    x2: 65.2747,
    y2: 89.1624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17055_49100",
    x1: 104.741,
    y1: 74.7678,
    x2: 104.741,
    y2: 89.1624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17055_49100",
    x1: 84.9515,
    y1: 22.0071,
    x2: 84.9515,
    y2: 104.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_17055_49100",
    x1: 85.0004,
    y1: 100.586,
    x2: 85.0004,
    y2: 106.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_17055_49100",
    x1: 84,
    y1: 71.5,
    x2: 79.4758,
    y2: 72.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_17055_49100",
    x1: 92.2123,
    y1: 48.5118,
    x2: 77.5589,
    y2: 49.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_17055_49100",
    x1: 95.0211,
    y1: 120.856,
    x2: 73.3084,
    y2: 121.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#246CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#1E68F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionIcon);
export default __webpack_public_path__ + "static/media/TransactionIcon.d4a8703a.svg";
export { ForwardRef as ReactComponent };